// Plain-data 2D vector helpers for the headless sim core.
//
// Distance metric — picked ONCE, sim-wide (ARCHITECTURE-SPINE.md#Consistency
// Conventions): autocol uses EUCLIDEAN distance for all range/steering math.
// Every sim system that measures distance MUST go through `dist` / `len` here
// so the choice stays consistent as later systems are built.

export interface Vec2 {
  x: number
  y: number
}

export function vec(x: number, y: number): Vec2 {
  return { x, y }
}

export function add(a: Vec2, b: Vec2): Vec2 {
  return { x: a.x + b.x, y: a.y + b.y }
}

export function sub(a: Vec2, b: Vec2): Vec2 {
  return { x: a.x - b.x, y: a.y - b.y }
}

export function scale(a: Vec2, s: number): Vec2 {
  return { x: a.x * s, y: a.y * s }
}

export function len(a: Vec2): number {
  return Math.sqrt(a.x * a.x + a.y * a.y)
}

export function dist(a: Vec2, b: Vec2): number {
  return len(sub(a, b))
}

/** Unit vector from a to b; returns {0,0} when the points coincide. */
export function dirTo(a: Vec2, b: Vec2): Vec2 {
  const d = sub(b, a)
  const l = len(d)
  return l === 0 ? { x: 0, y: 0 } : { x: d.x / l, y: d.y / l }
}
